import isNumber from './is-number';
import isString from './is-string';

export default function convertableToNumber(value) {
    return isNumber(value) || (isString(value) && isFinite(value));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts/dist/es/common/convertable-to-number.js
// module id = 2352
// module chunks = 29